





























import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import ModalDefault from '@/components/modal/default';
import ExtButton from '@/components/ext/Button.vue';
import { Wrapper as ContentWrapper } from './components';
import { Sidebar } from './blocks';
import store from '@/pages/profile/store';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    ContentWrapper,
    Sidebar,
    ModalDefault,
    ExtButton,
  },
})
export default class Index extends Vue {
  @Inject() $auth: any;

  showContent = false;

  get auth(): boolean {
    const { $store, $auth } = this;
    return $store.getters['user/isAuthorized'] || !!$auth.tokens;
  }

  get isModalWindow(): boolean {
    return store.isModalWindow;
  }

  get modalText() {
    return store.modalText;
  }

  get modalHeader() {
    return store.modalHeader;
  }

  get isNoButtons() {
    return store.isNoButtons;
  }

  get isSidebarButtons() {
    return store.isSidebarButtons;
  }

  get isDefaultButtons() {
    return store.isDefaultButtons;
  }

  get acceptButtonText() {
    return store.acceptButtonText;
  }

  get declineButtonText() {
    return store.declineButtonText;
  }

  get method() {
    return store.method;
  }

  beforeMount() {
    this.checkAuth();
  }

  mounted() {
    this.$nextTick(() => {
      this.showContent = this.auth;
    });
  }

  // beforeUpdate() {
  //   this.checkAuth();
  // }

  // beforeRouteUpdate(
  //   to: Route,
  //   from: Route,
  //   next: (value?: { name: string }) => void,
  // ) {
  //   this.auth ? next() : next({ path: '/' });
  // }

  closeModal() {
    store.closeModal();
  }

  acceptModal() {
    store.confirmed = true;
  }

  // Watch
  @Watch('auth')
  onAuthChanged(value: boolean) {
    if (value) {
      this.$router.go(0);
    }
  }

  checkAuth() {
    const { auth } = this;
    if (!auth) {
      this.$router.push({
        name: 'auth',
        query: { redirect: this.$route.name ? this.$route.name : '' },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/Index.vue